import WiredMono from "./WiredMono-Regular.otf"
import WiredMonoBold from "./WiredMono-Bold.otf"
import BreveTextBold from "./BreveText-Bold.woff"
import BreveTextBook from "./BreveText-Book.woff"
import Apercu from "./Apercu-Regular-Pro.woff"
import ApercuBold from "./Apercu-Bold-Pro.woff"
import ProximaNova from "./ProximaNova-Regular.woff"
import WiredMonoLight from "./WiredMono-Light.woff"

const fonts = {
  "@font-face": [
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMono}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMonoBold}') format("woff")`,
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Apercu",
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
      src: `url(${ApercuBold}) format("woff2"), url(${ApercuBold}) format("woff")`,
    },
    {
      fontFamily: "Apercu",
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
      src: `url(${Apercu}) format("woff2"), url(${Apercu}) format("woff")`,
    },
    {
      fontFamily: "BreveText",
      src: `url('${BreveTextBook}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "BreveText",
      src: `url('${BreveTextBold}') format("woff")`,
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMonoLight}') format("woff")`,
      fontWeight: 300,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMono}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMonoBold}') format("woff")`,
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "ProximaNova",
      src: `url('${ProximaNova}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
  ],
}

export default fonts
